export const SET_STSORDENESRX = "SET_STSORDENESRX";
export const UPDATE_STSORDENRX_IN_ARRAY = "UPDATE_STSORDENRX_IN_ARRAY";
export const ADD_STSORDENRX_IN_ARRAY = "ADD_STSORDENRX_IN_ARRAY";
